export default {
  Title: 'Καταγραφή Δραστηριότητας',

  Table: {
    Button: {
      View: {
        Title: 'Προβολή Καταγραφής Δραστηριότητας',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      }
    },

    Headers: {
      Id         : '#',
      Name       : 'Τύπος',
      Description: 'Ενέργεια',
      SubjectName: 'Τιμή',
      User       : 'Χρήστης',
      IpAddress  : 'Διεύθυνση IP',
      UserAgent  : 'Browser',
      Date       : 'Ημ/νία',
      Actions    : ''
    },

    Filter: {
      filterAction: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Ενέργεια',
        PlaceHolder: 'Όλες οι καταγραφές δραστηριότητας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Χρήστης',
        PlaceHolder: 'Όλες οι καταγραφές δραστηριότητας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterDate: {
        Type       : 'v-date-picker',
        Label      : 'Ημερομηνία',
        PlaceHolder: 'Επιλέξτε Ημερομηνία',
        Icon       : 'event'
      }
    }
  },

  Dialog: {
    View: {
      Toolbar: {
        Title   : 'Καταγραφή Δραστηριότητας',
        Subtitle: '',
        Icon    : 'mdi-history'
      },
      Header: {
        Type: 'Πεδίο',
        New : 'Νέα Τιμή',
        Old : 'Προηγούμενη Τιμή'
      }
    }
  }
}
